/**
 * Calculates a spacing value by multiplying the base spacing unit by the given {@link multiplier}.
 *
 * @param multiplier - The multiplier for the base spacing unit. Can be any positive or negative number.
 * @returns A CSS calc expression representing the computed spacing value using the CSS custom property --spacing
 *
 * @example
 * ```typescript
 * spacing(1)  // returns "calc(var(--spacing) * 1)"
 * ```
 */
export function spacing(multiplier: number): string {
	return `calc(var(--spacing) * ${multiplier})`;
}
